import { render, staticRenderFns } from "./basket-webitem.pug?vue&type=template&id=e7d43c84&lang=pug&"
import script from "./basket-webitem.js?vue&type=script&lang=js&"
export * from "./basket-webitem.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../developer-tools/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ../source/modules/HEA01-header/HEA01-header-basket/basket-webitem/basket-webitem.vue
// module id = 199
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 16 17 18